import { DriverQuestionLogic } from "./Question";
import { QualifiedFeature } from "fe-common/graphql";

//For questions that are not refactored into the new Driver logic yet.
export class LegacyQFDriverQuestion implements DriverQuestionLogic {
  answer(qfs: QualifiedFeature[]): QualifiedFeature[] {
    return qfs;
  }
}
